var _circle, _circle2, _g, _circle3, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFCF33",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.85,
    stroke: "#FFDE86",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_485_6539)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.3913,
    stroke: "#FFDE86",
    strokeOpacity: 0.6,
    strokeWidth: 1.04348
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.3913,
    stroke: "#FFDE86",
    strokeWidth: 1.04348
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_485_6539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3833 9.79374L10.1886 6.67664H17.5968L17.5968 6.67664V8.7817L14.2778 11.6834L14.4189 11.6762L17.617 12.1215L17.5968 12.1389V14.2265L14.0546 17.3234V15.2386L16.4184 13.1584L14.0344 15.221V17.3234H6.38331V15.1778L8.8527 14.8135V12.3036L6.38331 11.8988V9.79376H14.0344V11.6959L14.0546 11.6949V9.79374L14.0546 9.79374H6.3833Z",
    fill: "#FFD871",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2883 14.0866L14.3627 16.6444V15.378L16.6187 13.3927L17.2883 12.8134V14.0866ZM16.2133 12.9281L16.9099 12.3151L14.4896 11.9076L14.2619 12.1067C14.216 12.157 14.1533 12.1923 14.0818 12.2035L11.7516 12.5676V14.5456L13.9813 14.8591L16.2133 12.9281ZM17.2883 8.64176L14.3627 11.1995L14.3627 9.93316L17.2883 7.35867L17.2883 8.64176ZM16.7796 6.98499L13.9381 9.48549L7.24599 9.48551L10.2986 6.98499H16.7796ZM6.69141 11.637V10.1021L13.7259 10.1021V11.635L11.3957 11.9991C11.2457 12.0225 11.135 12.1518 11.135 12.3037V14.8136C11.135 14.9672 11.2482 15.0975 11.4004 15.1189L13.7259 15.4459V17.0151H6.69141V15.4441L8.8975 15.1186C9.04875 15.0962 9.1608 14.9665 9.1608 14.8136V12.3037C9.1608 12.1527 9.0514 12.0239 8.90237 11.9995L6.69141 11.637Z",
    fill: "url(#paint0_linear_485_6539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_485_6539",
    x: -0.0000424385,
    y: -0.0000424385,
    width: 24.0001,
    height: 24.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04348,
    result: "effect1_foregroundBlur_485_6539"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_485_6539",
    x: 0.957214,
    y: 1.25055,
    width: 22.0861,
    height: 21.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71304,
    result: "effect1_foregroundBlur_485_6539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_485_6539",
    x1: 13.5652,
    y1: 7.82616,
    x2: 6.78261,
    y2: 17.2175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/component.cf0c6c3130a93d1008c94faa2c1baf09.svg";
export { ForwardRef as ReactComponent };